import { CorpSessionInfo, RewardsAccount } from "redmond";

export const getBusinessEligibleAccounts = (
  accounts: RewardsAccount[],
  userInfo?: CorpSessionInfo
) => {
  return accounts.filter((account) =>
    userInfo
      ? account.accountReferenceId === userInfo.corporateInfo.accountReferenceId
      : isCorporateRewardsAccount(account)
  );
};

export const isCorporateRewardsAccount = (account: RewardsAccount) =>
  account.productDisplayName.toLowerCase().startsWith("spark") ||
  account.productDisplayName.toLowerCase().startsWith("venture x business") ||
  account.productDisplayName.toLowerCase().includes("business");

export const isConsumerRewardsAccount = (account: RewardsAccount) =>
  !isCorporateRewardsAccount(account);

const EM_ELIGIBLE_CARDS: string[] = [
  "SparkCash",
  "SparkCashPlus",
  "SparkCashPreferred",
  "SparkMiles",
  "SparkPro",
  "SparkProChargeCard",
  "VentureBusiness",
  "VentureXBusiness",
];

export const getIsEMEligible = (account?: RewardsAccount | null): boolean =>
  account?.caponeProduct
    ? EM_ELIGIBLE_CARDS.includes(account.caponeProduct)
    : false;
